'use strict';

var angular = require('angular');
var dependencies = ['AVRO.Common.Moment'];
module.exports = angular.module('AVRO.Common.DaysToDepartureCalculator', dependencies).factory('DaysToDepartureCalculatorService', require('./services/DaysToDepartureCalculatorService'));